
import Echo from 'laravel-echo'

import { io } from 'socket.io-client';

if (typeof window !== 'undefined') {
    window.io = io;
}
import { ENV_SOCKET_URL } from '../../plugins/replaces'

const state = {
    debug: false, // && process.env.NODE_ENV == 'development' ? true : false,
    listening: false,
    echo: new Echo({
        auth: {
            headers: {
                Accept: 'application/json',
                Client: process.env.VUE_APP_CLIENT_NAME
            }
        },
        broadcaster: "socket.io",
        host:
            ENV_SOCKET_URL +
            ":" +
            process.env.VUE_APP_SOCKET_PORT,
        encrypted: true,
        disableStats: true
    }),
    public: [
        {
            channel: '.test',
            event: 'test',
            dispatch: null,
            mutation: null
        },
        {
            channel: '.dashboard',
            event: 'lastwinners',
            dispatch: 'slot/initWinners',
            mutation: null
        },
        {
            channel: '.jackpot.pragmaticplay',
            event: 'jppp',
            //dispatch: 'slot/initWinners',
            mutation: 'setPragmaticJackpots'
        },
    ],
    private: [
        {
            channel: '.user.{user_id}',
            event: 'user',
            dispatch: 'auth/socketUser',
            mutation: null
        },
        {
            channel: '.user.{user_id}',
            event: 'balance',
            dispatch: 'auth/socketBalance',
            mutation: null
        },
    ]
}
const getters = {
    public(state) {
        return state.public
    },
    private(state) {
        return state.private
    },
    echo(state) {
        return state.echo
    },
    debug(){
        return state.debug
    }
}
const mutations = {
    TOKEN (state, payLoad) {
        if(payLoad){
            state.echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + payLoad
        } else {
            state.echo.connector.options.auth.headers['Authorization'] = null
        }
    },
    LISTENING (state, payLoad) {
        state.listening = payLoad;
    }
}
const actions = {
    initChannels ({commit, dispatch, getters, rootGetters}) {
        if(getters.debug){
            console.log('Initializing channels')
        }

        commit('LISTENING', false)
        getters.echo.disconnect();
        let token = rootGetters['auth/token'];
        commit('TOKEN', token)
        getters.echo.connect();

        getters.echo.connector.socket.on('connect', () => {
            console.log('Connected to Socket.IO server');
        });

        getters.echo.connector.socket.on('disconnect', () => {
            console.log('Disconnected from Socket.IO server');
        });

        getters.echo.connector.socket.on('connect_error', (error) => {
            console.log('Connection error:', error);
        });

        getters.public.forEach(listener => {
            /* PUBLIC CHANNELS */

            if(getters.debug){
                console.log('Connection Public channels... Listener: ' + listener.channel);
                console.log(process.env.VUE_APP_CLIENT_NAME.replaceAll('.', '')+ listener.channel);
            }

            getters.echo.channel(process.env.VUE_APP_CLIENT_NAME.replaceAll('.', '')+ listener.channel)
            .listen('.' + listener.event, payload => {
                if(getters.debug){
                    console.log(payload)
                }

                if(listener.dispatch){
                    dispatch(listener.dispatch, payload, { root: true })
                }
                
                if(listener.mutation){
                    commit(listener.mutation, payload, { root: true })
                }
            })
            /* PUBLIC CHANNELS */
        })
        if(getters.debug){
            console.log('Token: ' + token);
        }
        if(token){
            getters.private.forEach(listener => {
                /* PRIVATE CHANNELS */
                if(getters.debug){
                    console.log('Connection private channels, listener: ' + listener.channel);
                }
                let user = rootGetters['auth/user']
                if(user)
                {
                    if(getters.debug)
                    {
                        console.log(process.env.VUE_APP_CLIENT_NAME.replaceAll('.', '')+ listener.channel.replace("{user_id}", user.user_id));
                    }

                    getters.echo.private(process.env.VUE_APP_CLIENT_NAME.replaceAll('.', '')+ listener.channel.replace("{user_id}", user.user_id))
                    .listen('.' + listener.event.replace("{user_id}", user.user_id), payload => {
                        if(getters.debug){
                            console.log(payload)
                        }
        
                        if(listener.dispatch){
                            dispatch(listener.dispatch, payload, { root: true })
                        }
                        
                        if(listener.mutation){
                            commit(listener.mutation, payload, { root: true })
                        }
                    })
                }
                /* PRIVATE CHANNELS */
            })
        }

        commit('LISTENING', true)
    }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}